export default __webpack_public_path__ + "static/media/img5.1474e0ec.zoom";